(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mp-discovery"] && !Shopify.designMode) return;
  try {
    
(function(){
const norm=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
function init(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const cards=[...root.querySelectorAll('[data-product]')],search=root.querySelector('[data-search]'),stone=root.querySelector('[data-stone]'),sign=root.querySelector('[data-sign]');
 let category=new URLSearchParams(window.location.search).get('choix')||'all',limit=8; if(!['all','intention','astro','stone','custom','children'].includes(category))category='all'; if(new URLSearchParams(window.location.search).has('choix'))root.open=true;
 cards.sort((a,b)=>Number(b.dataset.available==='true')-Number(a.dataset.available==='true')).forEach(c=>c.parentElement.append(c));
 const stones=['Agate','Aigue-marine','Amazonite','Améthyste','Apatite','Aventurine','Bronzite','Calcédoine','Calcite','Célestine','Charoïte','Chrysocolle','Chrysoprase','Citrine','Cornaline','Cristal de roche','Fluorite','Grenat','Hématite','Howlite','Jade','Jaspe','Kunzite','Labradorite','Lapis lazuli','Lépidolite','Malachite','Morganite','Obsidienne','Œil de tigre','Œil de faucon','Œil de taureau','Onyx','Opale','Péridot','Pierre de lune','Pierre de soleil','Préhnite','Quartz rose','Quartz fumé','Rhodonite','Rhodochrosite','Sélénite','Serpentine','Shungite','Sodalite','Tourmaline','Turquoise','Unakite'];
 const normalized=s=>norm(s.replace(/œ/g,'oe').replace(/Œ/g,'Oe'));
 stones.filter(s=>cards.some(c=>normalized(c.dataset.title).includes(normalized(s)))).forEach(s=>stone.add(new Option(s,normalized(s))));
 ['Bélier','Taureau','Gémeaux','Cancer','Lion','Vierge','Balance','Scorpion','Sagittaire','Capricorne','Verseau','Poissons'].forEach(s=>sign.add(new Option(s,norm(s))));
 function update(){
 const words=normalized(search.value).split(' ').filter(Boolean);
 const matched=cards.filter(c=>{const title=normalized(c.dataset.title),tags=normalized(c.dataset.tags);let ok=category==='all'||c.dataset.kind===category;if(category==='children')ok=tags.includes('bracelets pour enfants')||/taille enfant|pour enfant|bracelet enfant/.test(title);return ok&&words.every(w=>title.includes(w))&&(!stone.value||title.includes(stone.value))&&(!sign.value||(' '+title+' ').includes(' '+sign.value+' '));});
 const visible=new Set(matched.slice(0,limit));cards.forEach(c=>c.hidden=!visible.has(c));root.querySelector('[data-count]').textContent=matched.length;root.querySelector('[data-empty]').hidden=matched.length!==0;root.querySelector('[data-more]').hidden=matched.length<=limit;root.querySelector('[data-stone-label]').hidden=category!=='stone';root.querySelector('[data-sign-label]').hidden=category!=='astro';root.querySelectorAll('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category===category)));
 }
 root.querySelectorAll('[data-category]').forEach(b=>b.addEventListener('click',()=>{category=b.dataset.category;stone.value='';sign.value='';limit=8;update();}));
 [search,stone,sign].forEach(el=>el.addEventListener('input',()=>{limit=8;update();}));
 root.querySelector('[data-more]').addEventListener('click',()=>{limit+=12;update();});root.querySelector('[data-reset]').addEventListener('click',()=>{category='all';search.value='';stone.value='';sign.value='';limit=8;update();});root.querySelector('.mp-controls').hidden=false;update();
}
function start(){document.querySelectorAll('[data-mp-discovery]').forEach(init)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();document.addEventListener('shopify:section:load',start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-header"]) return;
  try {
    
document.querySelectorAll('.mp2-header').forEach(function(header){
  var menuButton=header.querySelector('.mp2-menu-toggle');
  header.setAttribute('data-menu-ready','');

  function closeSubmenus(except){
    header.querySelectorAll('.mp2-nav-parent').forEach(function(parent){
      if(parent===except)return;
      var toggle=parent.querySelector('.mp2-submenu-toggle');
      var dropdown=parent.querySelector('.mp2-dropdown');
      parent.removeAttribute('data-submenu-open');
      if(toggle)toggle.setAttribute('aria-expanded','false');
      if(dropdown)dropdown.hidden=true;
    });
  }

  if(menuButton){
    menuButton.addEventListener('click',function(){
      var opened=header.toggleAttribute('data-menu-open');
      menuButton.setAttribute('aria-expanded',String(opened));
      if(!opened)closeSubmenus();
    });
  }

  header.querySelectorAll('.mp2-submenu-toggle').forEach(function(toggle){
    toggle.addEventListener('click',function(event){
      event.preventDefault();
      event.stopPropagation();
      var parent=toggle.closest('.mp2-nav-parent');
      var dropdown=parent ? parent.querySelector('.mp2-dropdown') : null;
      if(!parent||!dropdown)return;
      var opening=toggle.getAttribute('aria-expanded')!=='true';
      closeSubmenus(parent);
      toggle.setAttribute('aria-expanded',String(opening));
      if(opening){parent.setAttribute('data-submenu-open','');dropdown.hidden=false;}
      else{parent.removeAttribute('data-submenu-open');dropdown.hidden=true;}
    });
  });

  document.addEventListener('click',function(event){
    if(!header.contains(event.target))closeSubmenus();
  });

  header.addEventListener('keydown',function(event){
    if(event.key==='Escape'){
      var active=header.querySelector('.mp2-submenu-toggle[aria-expanded="true"]');
      if(active){closeSubmenus();active.focus();return;}
      if(header.hasAttribute('data-menu-open')){
        header.removeAttribute('data-menu-open');
        if(menuButton){menuButton.setAttribute('aria-expanded','false');menuButton.focus();}
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mp2-home').forEach(function(root){var buttons=root.querySelectorAll('[data-mp-selection]');var panels=root.querySelectorAll('[data-mp-panel]');if(!buttons.length)return;root.setAttribute('data-selection-ready','');function choose(key){buttons.forEach(function(button){button.setAttribute('aria-pressed',String(button.dataset.mpSelection===key));});panels.forEach(function(panel){panel.hidden=panel.dataset.mpPanel!==key;});}buttons.forEach(function(button){button.addEventListener('click',function(){choose(button.dataset.mpSelection);});});choose('favorites');});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-stone-directory"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mp-stones').forEach(function(root){var input=root.querySelector('input');var cards=Array.from(root.querySelectorAll('[data-stone]'));var normalize=function(value){return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/œ/g,'oe').trim();};input.addEventListener('input',function(){var query=normalize(input.value);var count=0;cards.forEach(function(card){card.hidden=!normalize(card.dataset.stone).includes(query);if(!card.hidden)count++;});root.querySelector('.mp-stones-empty').hidden=count>0;});});

  } catch(e) { console.error(e); }
})();
})();
